var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never"}},[_c('el-row',[_c('el-button',{staticClass:"btn",attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.exportData}},[_vm._v("导出键盘进出存报表")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }